import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import SlackChannel from "./SlackChannel";

export default function ChannelSettings() {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Configuração de Canais</CardTitle>
          <CardDescription>
            Configure os canais de comunicação para receber e responder mensagens
          </CardDescription>
        </CardHeader>
        <CardContent>
          <SlackChannel />
        </CardContent>
      </Card>
    </div>
  );
}
